import { render, staticRenderFns } from "./TakePicture.vue?vue&type=template&id=4f9a86a4&"
import script from "./TakePicture.vue?vue&type=script&lang=js&"
export * from "./TakePicture.vue?vue&type=script&lang=js&"
import style0 from "./TakePicture.vue?vue&type=style&index=0&id=4f9a86a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports